/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  PARTICIPANT_STATUS_VIEW_LOADING,
  PARTICIPANT_STATUS_VIEW_ERROR,
  PARTICIPANT_STATUS_FETCH
} from '../actions/actionTypes';

const participantStatusState = {
  error: null,
  isLoading: false,
  participantStatuses: null
};

const participantStatusReducer = (state = participantStatusState, action) => {
  switch (action.type) {
    case PARTICIPANT_STATUS_VIEW_ERROR:
      return Object.assign({}, state, { error: action.payload, isLoading: false });
    case PARTICIPANT_STATUS_VIEW_LOADING:
      return Object.assign({}, state, { participantStatuses: null, isLoading: true, error: null });
    case PARTICIPANT_STATUS_FETCH:
      return Object.assign({}, state, { participantStatuses: action.payload, isLoading: false, error: null });
    default:
      return state;
  }
};

export default participantStatusReducer;
